import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/financial-leverage-calculator',
  component: () => import('../../routes/FinancialLeverage.svelte'),
  card: {
    id: 'financial-leverage-calculator',
    title: 'Financial Leverage',
    description:
      'Calculate the Degree of Financial Leverage (DFL), interest coverage, and combined leverage. See how debt amplifies or dampens EPS changes with EBIT fluctuations.',
    icon: 'account_balance',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/financial-leverage-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Financial Leverage Calculator – Degree of Financial Leverage (DFL)',
    description:
      'Free Financial Leverage calculator calculates DFL, interest coverage ratio, and combined leverage (DCL). Understand how debt amplifies EPS sensitivity to EBIT changes for smarter capital structure decisions.',
  },
};

export default meta;